function toggleProductInWishlist(product_id, product_handle, variant_id) {
  let productInfo = {
    id: product_id,
    handle: product_handle,
    variant_id: variant_id,
  };

  let cookieStr = JSON.stringify(productInfo);
  let currentWishlist = getCookie("wishlist");
  let currentWishlistArray = currentWishlist.split("_SPLIT_");
  if (currentWishlistArray.includes(cookieStr)) {
    removeProductFromWishlist(variant_id);
  } else {
    if (currentWishlist) {
      cookieStr = currentWishlist + "_SPLIT_" + cookieStr;
    }
    setCookie("wishlist", cookieStr, 60);
  }
}

function removeProductFromWishlist(id) {
  let wishlist = getCookie("wishlist").split("_SPLIT_");
  let filteredWishlist = [];
  wishlist.forEach((item) => {
    if (filteredWishlist.indexOf(item) === -1) {
      filteredWishlist.push(item);
    }
  });
  let newWishlist = filteredWishlist.filter((item) => {
    if (typeof id != "string") {
      id = id.toString();
    }
    return JSON.parse(item).variant_id !== id;
  });
  let cookieStr = newWishlist.join("_SPLIT_");
  setCookie("wishlist", cookieStr, 60);
  updateWishlistCount();
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  updateWishlistCount();
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function updateWishlistCount() {
  let wishlist = getCookie("wishlist");
  let wishlistArray = [];
  if (wishlist) {
    wishlistArray = wishlist.split("_SPLIT_");
  }
  let filteredWishlist = [];
  wishlistArray.forEach((item) => {
    if (filteredWishlist.indexOf(item) === -1) {
      filteredWishlist.push(item);
    }
  });
  document
    .querySelectorAll("#wishlist-count")
    .forEach((el) => (el.innerText = filteredWishlist.length));
}

updateWishlistCount();

function updateWishlistIcon(variant) {
    let wishlist = getCookie('wishlist').split('_SPLIT_');
    let filteredWishlist = [];
    if (wishlist.length > 0 && wishlist[0] !== "") {
      wishlist.forEach((item) => {
        if (filteredWishlist.indexOf(item) === -1) {
          filteredWishlist.push(item);
        }
      });
    }
    let variant_id = variant;
    let isInWishlist = false;
    filteredWishlist.forEach(el => {
      if (typeof variant_id != 'string') {
        variant_id = variant_id.toString();
      }
      if (JSON.parse(el).variant_id === variant_id) {
        isInWishlist = true;
        document.querySelector('.wishlist.icon-button svg path').setAttribute('fill', '#A1CC82');
        document.querySelector('.wishlist.icon-button svg path').setAttribute('color', '#A1CC82');
      }
    })
    if (!isInWishlist) {
      document.querySelector('.wishlist.icon-button svg path').setAttribute('fill', 'none');
      document.querySelector('.wishlist.icon-button svg path').setAttribute('color', 'currentColor');
    }
    const url = window.location.href;
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;
    const parts = pathname.split('/');
    const productsIndex = parts.indexOf('products');
    let handle = '';
    if (productsIndex !== -1 && productsIndex + 1 < parts.length) {
        handle = parts[productsIndex + 1];
    }
    fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
        .then(response => response.json())
        .then(product => {
            document.querySelector('.wishlist.icon-button').setAttribute('onclick', `toggleProductInWishlist('${product.id}', '${product.handle}', '${variant_id}'); updateWishlistIconColor()`);
        });
  }
